<template>
  <section class='question'>
    <h2
      class='question_title'
      tabindex="0"
      aria-live="polite"
      ref="question"
      aria-atomic="true"
    >
      {{ title }}
    </h2>
    <div class='question_answers'>
      <slot />
    </div>
  </section>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  props: {
    title: {
      type: String,
      default: '~~~~~~~',
    },
  },
  mounted() {
    this.$refs.question.focus(); // for accessibility
  },
  methods: {
    ...mapMutations([
      'goToPreviousPage', 'goToNextPage'
    ]),
  },
};
</script>
